import classNames from 'classnames';

const GreetingQuestionItem = ({ containerClass, icon, query, onClick }) => {
    return (
        <div
            className={classNames('question__buttons', containerClass)}
            onClick={() => onClick()}
            onKeyPress={(e) => e.key === 'Enter' && onClick()}
            tabIndex={0}
            role="button"
            aria-label={query}
        >
            {query}
            <div className="button__icon">
                <img src={icon} alt={query} />
            </div>
        </div>
    );
};

export default GreetingQuestionItem;
